export default {
	items: [],
	next_page_index: 1,
    start_record: 0,
    length_record: 40,
    default_market_id: 5,
    total_record: 0,
    is_bond_scanner: 0,
}